import { DISCHARGE_CRITERIA_FIELD_NAMES } from '../../../../../../store/treatmentPlanV3';

import type { DischargeCriteriaFieldName } from '../../../../../../store/treatmentPlanV3';
import type { DischargeCriteriaFormValues, DischargeCriteriaSavedFieldValues } from '../types';

export function getChangedDischargeFieldValues(
  values: DischargeCriteriaFormValues,
  savedValues: DischargeCriteriaSavedFieldValues,
): DischargeCriteriaSavedFieldValues {
  return DISCHARGE_CRITERIA_FIELD_NAMES.reduce<DischargeCriteriaSavedFieldValues>(
    (changed, name) => {
      if (savedValues[name] === values[name]) {
        return changed;
      }
      return { ...changed, [name]: values[name] };
    },
    {},
  );
}

export function getDischargeValuesWithFieldOverride(
  values: DischargeCriteriaFormValues,
  name: DischargeCriteriaFieldName,
  value: string | undefined,
): DischargeCriteriaFormValues {
  if (value === undefined) {
    return values;
  }
  return { ...values, [name]: value };
}
